import React, { useEffect, useRef } from "react";
import styles from "./MainLayout.module.scss";
import Header from "@/components/layout/headers/Header/Header";
import Head from "next/head";
import Footer from "@/components/layout/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/types/RootState";
import NotificationPanel from "../NotificationPanel";
import { useRouter } from "next/router";
import { useMediaQuery } from "@mui/material";
import useNetworkStatus from "@/hooks/useNetworkStatus";
import { addNotification } from "@/redux/reducer/notificationSlice";
import AppDownloadSection from "@/components/layout/AppDownloadSection/AppDownloadSection";
import { useScrollContext } from "@/context/ScrollContext";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const notifications = useSelector((state: RootState) => state.notification);
  const router = useRouter();
  const { isOnline } = useNetworkStatus();

  const isMobile = useMediaQuery("(max-width:991px)");
  const { pathname } = router;
  const hideHeader =
    (pathname === "/search" || pathname === "/search/hotel/[id]") && isMobile;

  const dispatch = useDispatch();
  const previousIsOnline = useRef<boolean | null>(null);

  useEffect(() => {
    if (previousIsOnline.current === null) {
      previousIsOnline.current = isOnline;
      return;
    }
    if (isOnline !== previousIsOnline.current) {
      if (!isOnline) {
        dispatch(
          addNotification({
            type: "error",
            title: "Connection Error",
            subtitle: "Connection lost. Please check your internet connection.",
          })
        );
      } else {
        dispatch(
          addNotification({
            type: "success",
            title: "Connection Restored",
            subtitle: "Your internet connection has been restored.",
          })
        );
        // retryQueuedRequests();
        // router.replace(router.asPath);

        // router.reload();
      }
      previousIsOnline.current = isOnline;
    }
  }, [isOnline, dispatch]);

  const { showHeader } = useScrollContext();

// const shouldHideHeader =
//   (pathname === "/search" || pathname === "/search/hotel/[id]") && isMobile;

// // Final decision:
// const renderHeader = !shouldHideHeader || (shouldHideHeader && showHeader);
  const hideHeaderOnMobileSearch =
    (pathname === "/search" ||  pathname.startsWith("/search/hotel/")) &&
    isMobile;

 const renderHeader = !hideHeaderOnMobileSearch ;
  return (
    <div className={styles.MainLayout} data-testid="MainLayout">
      <Head>
        <title>Almuayed</title>
      </Head>

      {renderHeader  && <Header show={showHeader} />}

      <main >
        <NotificationPanel notifications={notifications} />
        {children}
      </main>

    {
      pathname !== "/checkout/[id]"  && 
      <AppDownloadSection />
    }  
      <Footer />
    </div>
  );
};

export default MainLayout;
